import 'leaflet/dist/leaflet.css';
import 'reflect-metadata';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';

// Yeni deploy sonrası eski hash'li chunk'lar 404 dönerse otomatik reload.
// Sonsuz döngüyü önlemek için sessionStorage flag kullanılır.
const VITE_RELOAD_FLAG = 'vite-preload-reload';
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (sessionStorage.getItem(VITE_RELOAD_FLAG)) {
    return;
  }
  sessionStorage.setItem(VITE_RELOAD_FLAG, '1');
  window.location.reload();
});
window.addEventListener('load', () => {
  sessionStorage.removeItem(VITE_RELOAD_FLAG);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
